<template>
  <div
      class="w-4 h-4 rounded"
      :style="{ backgroundColor: color }"
  ></div>
</template>

<script>
export default {
  name: "ColorRenderer",
  props: ["params"],
  data() {
    return {
        color: '#000000'
    };
  },
  created() {
    if( this.params.value.startsWith('#') ) {
      this.color = this.params.value;
    } else if( this.params.value.length === 6 ) {
      this.color = '#' + this.params.value;
    } else {
      this.color = '#000000';
    }
  },
  methods: {
    getValue() {
      return this.color.slice(1);
    },
    isPopup() {
      return true;
    }
  }
};
</script>

<style scoped>
/* Minimal styling */
</style>